import { HUB_EVENTS, hubEmitter } from '@/core/realtime';
import { type MessageListData, messageListKeys } from '@/features/message-list';
import type { MessageReactionsUpdateDto } from '@/features/message-list/models/message-reaction';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

export const useMessageReactionUpdatedEvent = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const handleMessageReactionUpdated = (reactionUpdate: MessageReactionsUpdateDto) => {
      queryClient.setQueryData<MessageListData>(messageListKeys.conversation(reactionUpdate.conversationId), (data) => {
        if (!data) {
          return data;
        }

        // Kiểm tra nếu messageId thực đã tồn tại
        const messageExists = data.pages.some((page) =>
          page.some((existingMsg) => existingMsg.messageId === reactionUpdate.messageId)
        );

        if (!messageExists) {
          return data;
        }

        // Tạo shallow copy của tất cả pages
        const updatedPages = data.pages.map((page) => [...page]);

        // Tìm và cập nhật reactions của message
        for (let pageIndex = 0; pageIndex < updatedPages.length; pageIndex++) {
          const page = updatedPages[pageIndex];
          const msgIndex = page.findIndex((existingMsg) => existingMsg.messageId === reactionUpdate.messageId);

          if (msgIndex !== -1) {
            const currentMessage = updatedPages[pageIndex][msgIndex];
            updatedPages[pageIndex][msgIndex] = {
              ...currentMessage,
              reactions: reactionUpdate.updatedReactions
            };
            break;
          }
        }

        return {
          pages: updatedPages,
          pageParams: data.pageParams
        };
      });
    };

    hubEmitter.on(HUB_EVENTS.MESSAGE.REACTIONS_UPDATED, handleMessageReactionUpdated);

    return () => {
      hubEmitter.off(HUB_EVENTS.MESSAGE.REACTIONS_UPDATED, handleMessageReactionUpdated);
    };
  }, [queryClient]);
};
